module.exports = __webpack_public_path__ + "static/media/steamcouture-logo.5e12afd9.jpg";